<template>
  <AdminShell>
    <slot />
  </AdminShell>
</template>

<script setup lang="ts">
import AdminShell from '~/components/layout/AdminShell.vue'
</script>
